import { useTranslation } from 'react-i18next'

import { Flex, Typography } from '@percent/lemonade'
import { Step } from '@percent/education-hosted-form/ui/Step/Step'
import styles from './ResultPage.module.scss'
import { ResultPageProps } from './ResultPage.types'
import { useEducationHostedForm } from '@percent/education-hosted-form/hooks/useEducationHostedForm/useEducationHostedForm'
import { useRedirectUserAfterComplete } from '@percent/education-hosted-form/hooks/useRedirectUserAfterComplete/useRedirectUserAfterComplete'
import { useTrackEvent } from '@percent/education-hosted-form/analytics/useTrackEvent'

const REDIRECT_DELAY_SECONDS = 5

export function ResultPage({
  description,
  imgSrc,
  title,
  helpCenterUrl,
  shouldRedirect = true,
  step
}: ResultPageProps) {
  const { t } = useTranslation()
  const trackEvent = useTrackEvent()
  const { partnerConfig } = useEducationHostedForm()
  useRedirectUserAfterComplete(shouldRedirect, REDIRECT_DELAY_SECONDS)

  const partnerName = partnerConfig?.partner.name
  const titleText = t(title) as string
  const descriptionText = t(description, { partnerName }) as string
  const redirectUrl = partnerConfig?.redirectUrl

  return (
    <Step progress={100}>
      <Flex direction="column" align="center" gap={56} pt={48}>
        <img alt={titleText} src={imgSrc} />
        <div className={styles.textWrapper}>
          <Typography variant="h2" className={styles.title}>
            {titleText}
          </Typography>
          <Typography className={styles.description}>
            {descriptionText}
            {helpCenterUrl && (
              <a
                href={helpCenterUrl}
                className={styles.helpCenterLink}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent('education_form_button_clicked', { button: 'help_center', step })}
              >
                {t('typography.helpCenter')}
              </a>
            )}
          </Typography>
          {redirectUrl && (
            <>
              {shouldRedirect && (
                <Typography className={styles.description}>
                  {t('resultPage.redirect', { partnerName, redirectDelay: REDIRECT_DELAY_SECONDS })}
                </Typography>
              )}
              <a href={redirectUrl} className={styles.redirectLink} rel="noopener noreferrer">
                {t('resultPage.goToPartner', { partnerName })}
              </a>
            </>
          )}
        </div>
      </Flex>
    </Step>
  )
}
